// extracted by mini-css-extract-plugin
export default {"employee-container":"LoanRequest_employee-container__Rq4JL","loan-header":"LoanRequest_loan-header__kQw4g","loan-header__buttons":"LoanRequest_loan-header__buttons__BbPWe"};